module.exports = __webpack_public_path__ + "img/lanya.880282d0.png";